import React, { useState } from "react";
import API_URLS from "../../summaryapi/apiUrls";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import LogoV from "../../assets/LogoV.png"
const StudentEnrollmentForm = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    gender: "",
    current_class: "",
    current_school_name: "",
    current_fee: "",
    joining_class: "",
    class_fee: "",
    remarks: "",
    parents_name: "",
    parent_aadhar:"",
    student_aadhar:"",
    mobile_number: "",
    alternate_mobile_number: "",
    city: "",
    address: "",
    income: "",
    caste: "",
    is_interested: 1,
    is_active: 1
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const employeeName = sessionStorage.getItem("employeeName");



  const classOptions = [
    { value: 1, label: "Pre-KG" },
    { value: 2, label: "LKG" },
    { value: 3, label: "UKG" },
    { value: 4, label: "Class 1" },
    { value: 5, label: "Class 2" },
    { value: 6, label: "Class 3" },
    { value: 7, label: "Class 4" },
    { value: 8, label: "Class 5" },
    { value: 9, label: "Class 6" },
    { value: 10, label: "Class 7" },
    { value: 11, label: "Class 8" },
    { value: 12, label: "Class 9" },
    { value: 13, label: "Class 10" },
  ];
  




  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Only allow numbers (0-9) for mobile number fields
    if (name === 'mobile_number' || name === 'alternate_mobile_number') {
      const numericValue = value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
      setFormData({
        ...formData,
        [name]: numericValue
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: checked ? 1 : 0
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess(false);
  
    const employee_id = sessionStorage.getItem("employeeId");
  
    if (!employee_id) {
      setError("Employee is not logged in.");
      setLoading(false);
      return;
    }
  
    const payload = {
      ...formData,
      employee_id: employee_id
    };
  
    try {
      const response = await fetch(API_URLS.createstudent.url, {
        method: API_URLS.createstudent.method,
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });
  
      const result = await response.json();
  
      if (result.status) {
        setSuccess(true);
        toast.success("Student enrolled successfully!", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setFormData({
          full_name: "",
          gender: "",
          current_class: "",
          current_school_name: "",
          current_fee: "",
          joining_class: "",
          class_fee: "",
          remarks: "",
          parents_name: "",
          mobile_number: "",
          alternate_mobile_number: "",
          city: "",
          address: "",
          income: "",
          caste: "",
          is_interested: 1,
          is_active: 1,
          parent_aadhar: "",
          student_aadhar: "",
        });
      } else {
        toast.error(result.message || "Failed to create student", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (err) {

     
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="max-w-4xl p-6 bg-white rounded-lg shadow-md"
      style={{ maxHeight: "90vh", overflowY: "auto" }}
    >


<div className="flex items-center justify-center space-x-4 mb-4">
          <img src={LogoV} alt="Logo" className="h-15 w-18 object-contain" />
          <h1 className="text-2xl font-bold text-gray-800 mb-6 mt-2 text-center sticky top-0 bg-white py-4 z-10">
          <strong>తల్లికి వందనం</strong><br/> <span className="text-xl">Student Enrollment Form</span>
      </h1>
 
        </div>
       <h1><strong className="block text-gray-700 mb-1 text-end">Voluntary Name : {employeeName}</strong></h1> 

      {success && (
        <div className="mb-4 p-4 bg-green-100 text-green-700 rounded sticky top-16 bg-white z-10">
          Student enrolled successfully!
        </div>
      )}

      {error && (
        <div className="mb-4 p-4 bg-red-100 text-red-700 rounded sticky top-16 bg-white z-10">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Student Info */}
        <fieldset className="border p-4 rounded-md">
          <legend className="text-lg font-semibold px-2">Student Information</legend>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-700 mb-1">Full Name*</label>
              <input
                type="text"
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
                className="w-full p-2 border rounded-md"
                required
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-1">Gender*</label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                className="w-full p-2 border rounded-md"
                required
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div>
              <label className="block text-gray-700 mb-1">Current Class*</label>
              <select
  name="current_class"
  value={formData.current_class}
  onChange={handleChange}
  className="w-full p-2 border rounded-md"
  required
>
  <option value="">Select Class</option>
  {classOptions.map((option) => (
    <option key={option.value} value={option.value}>
      {option.label}
    </option>
  ))}
</select>

            </div>

            <div>
              <label className="block text-gray-700 mb-1">Current School Name</label>
              <input
                type="text"
                name="current_school_name"
                value={formData.current_school_name}
                onChange={handleChange}
                className="w-full p-2 border rounded-md"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-1">Current Class Fee</label>
              <input
                type="number"
                name="current_fee"
                value={formData.current_fee}
                onChange={handleChange}
                className="w-full p-2 border rounded-md"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-1">Joining Class</label>
              <select
  name="joining_class"
  value={formData.joining_class}
  onChange={handleChange}
  className="w-full p-2 border rounded-md"
>
  <option value="">Select Class</option>
  {classOptions.map((option) => (
    <option key={option.value} value={option.value}>
      {option.label}
    </option>
  ))}
</select>

            </div>

            <div>
              <label className="block text-gray-700 mb-1">Class Fee</label>
              <input
                type="number"
                name="class_fee"
                value={formData.class_fee}
                onChange={handleChange}
                className="w-full p-2 border rounded-md"
              />
            </div>
            <div>
  <label className="block text-gray-700 mb-1">Aadhar Number*</label>
  <input
    type="text"
    name="student_aadhar"
    value={formData.student_aadhar}
    onChange={(e) => {
      const re = /^[0-9\b]+$/;
      if (e.target.value === '' || re.test(e.target.value)) {
        handleChange(e);
      }
    }}
    className="w-full p-2 border rounded-md"
    maxLength={12}
  />
</div>

            <div className="md:col-span-2">
              <label className="block text-gray-700 mb-1">Remarks</label>
              <textarea
                name="remarks"
                value={formData.remarks}
                onChange={handleChange}
                className="w-full p-2 border rounded-md"
                rows="2"
              />
            </div>


            

          </div>
        </fieldset>

        {/* Parent Info */}
        <fieldset className="border p-4 rounded-md">
          <legend className="text-lg font-semibold px-2">Parent Information</legend>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-700 mb-1">Parents Name*</label>
              <input
                type="text"
                name="parents_name"
                value={formData.parents_name}
                onChange={handleChange}
                className="w-full p-2 border rounded-md"
                required
              />
            </div>

            <div>
  <label className="block text-gray-700 mb-1">Mobile Number*</label>
  <input
    type="tel"
    name="mobile_number"
    value={formData.mobile_number}
    onChange={handleChange}
    className="w-full p-2 border rounded-md"
    required
    maxLength={10}
    pattern="[0-9]{10}"
    title="Please enter exactly 10 digits"
    inputMode="numeric"
  />
  {formData.mobile_number.length < 10 && formData.mobile_number.length > 0 && (
    <p className="text-red-500 text-xs mt-1">Mobile number must be 10 digits</p>
  )}
</div>

<div>
  <label className="block text-gray-700 mb-1">Alternate Mobile</label>
  <input
    type="tel"
    name="alternate_mobile_number"
    value={formData.alternate_mobile_number}
    onChange={handleChange}
    className="w-full p-2 border rounded-md"
    maxLength={10}
    pattern="[0-9]{10}"
    title="Please enter exactly 10 digits"
    inputMode="numeric"
  />
  {formData.alternate_mobile_number.length < 10 && formData.alternate_mobile_number.length > 0 && (
    <p className="text-red-500 text-xs mt-1">Alternate mobile number must be 10 digits</p>
  )}
</div>

            <div>
              <label className="block text-gray-700 mb-1">City</label>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                className="w-full p-2 border rounded-md"
              />
            </div>

            <div className="md:col-span-2">
              <label className="block text-gray-700 mb-1">Address</label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                className="w-full p-2 border rounded-md"
                rows="3"
              />
            </div>

  
            <div>
  <label className="block text-gray-700 mb-1">Parent Aadhar Number*</label>
  <input
    type="text"
    name="parent_aadhar"
    value={formData.parent_aadhar}
    onChange={(e) => {
      const re = /^[0-9\b]+$/;
      if (e.target.value === '' || re.test(e.target.value)) {
        handleChange(e);
      }
    }}
    className="w-full p-2 border rounded-md"
    maxLength={12}
  />
</div>



            <div>
              <label className="block text-gray-700 mb-1">Income</label>
              <input
                type="text"
                name="income"
                value={formData.income}
                onChange={handleChange}
                className="w-full p-2 border rounded-md"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-1">Caste</label>
              <input
                type="text"
                name="caste"
                value={formData.caste}
                onChange={handleChange}
                className="w-full p-2 border rounded-md"
              />
            </div>
          </div>
        </fieldset>

        {/* Status Toggles */}
        <fieldset className="border p-4 rounded-md">
          <legend className="text-lg font-semibold px-2">Admission Status</legend>
          <div className="flex items-center space-x-4">
            <label className="text-gray-700">Interested to Join:</label>
            <label className="inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                name="is_interested"
                checked={formData.is_interested === 1}
                onChange={handleCheckboxChange}
                className="sr-only peer"
              />
              <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-blue-600 after:absolute after:top-[2px] after:left-[2px] after:bg-white after:h-5 after:w-5 after:rounded-full after:transition-all peer-checked:after:translate-x-full"></div>
              <span className="ml-2 text-sm text-gray-700">
                {formData.is_interested === 1 ? "Yes" : "No"}
              </span>
            </label>
          </div>

          <div className="mt-4 flex items-center space-x-4">
            <label className="text-gray-700">Active Status:</label>
            <label className="inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                name="is_active"
                checked={formData.is_active === 1}
                onChange={handleCheckboxChange}
                className="sr-only peer"
              />
              <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-green-600 after:absolute after:top-[2px] after:left-[2px] after:bg-white after:h-5 after:w-5 after:rounded-full after:transition-all peer-checked:after:translate-x-full"></div>
              <span className="ml-2 text-sm text-gray-700">
                {formData.is_active === 1 ? "Active" : "Inactive"}
              </span>
            </label>
          </div>
        </fieldset>

        <div className="text-center sticky bottom-0 bg-white py-4 z-10">
          <button
            type="submit"
            disabled={loading}
            className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-md transition duration-200 disabled:opacity-50"
          >
            {loading ? "Processing..." : "Enroll Student"}
          </button>
        </div>
      </form>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
    
  );
};

export default StudentEnrollmentForm;
